import approvalRequestsService from "../../../../services/procurementService/approvalRequestsService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_APPROVALREQUESTSBYPURCHASEORDERID } from "../../../../utils/constants";
import { ApprovalRequestInterface } from "../../../../models/ProcurementModule/ApprovalRequest";

const useApprovalRequestByPurchaseOrderId = (
  purchaseOrderId: string | undefined
) =>
  useQuery<ApprovalRequestInterface[], Error>({
    queryKey: [CACHE_KEY_APPROVALREQUESTSBYPURCHASEORDERID, purchaseOrderId],
    queryFn: () =>
      approvalRequestsService.GetByPurchaseOrderId(purchaseOrderId),
    initialData: [],
    enabled: !!purchaseOrderId,
  });

export default useApprovalRequestByPurchaseOrderId;
